import React from "react";
import { Flex, Header, Input, Text, Button } from "@fluentui/react-northstar";
import { Modal } from "ecom-teams-apps-core";
import styles from "./loginModal.module.scss";
import pl from "shared/messages/pl";
import { constants } from "shared/constants";

interface LoginModalProps {
    setLogin: (login: string) => void;
    setPassword: (password: string) => void;
    onAuthorize: () => void;
}

const LoginModal: React.FC<LoginModalProps> = (props: LoginModalProps) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === constants.enterKeyCode) {
            props.onAuthorize();
        }
    };

    return (
        <Modal isOpen withOverlay>
            <div className={styles.modalWrapper}>
                <Header as="h1" content={pl.authProvider.developmentAuth.header} />
                <Text size="large" content={pl.authProvider.developmentAuth.message}></Text>
                <Flex column gap="gap.medium" className={styles.loginFormWrapper}>
                    <Input
                        onKeyDown={handleKeyDown}
                        fluid
                        clearable
                        placeholder={pl.authProvider.developmentAuth.form.login}
                        onChange={(e) => props.setLogin((e.currentTarget as EventTarget & HTMLInputElement).value)}
                    />
                    <Input
                        onKeyDown={handleKeyDown}
                        fluid
                        type="password"
                        placeholder={pl.authProvider.developmentAuth.form.password}
                        onChange={(e) => props.setPassword((e.currentTarget as EventTarget & HTMLInputElement).value)}
                    />
                    <Flex hAlign="end">
                        <Button
                            content={pl.authProvider.developmentAuth.form.submit}
                            primary
                            onClick={props.onAuthorize}
                        />
                    </Flex>
                </Flex>
            </div>
        </Modal>
    );
};

export default LoginModal;
